module.exports = __webpack_public_path__ + "img/psd.c719427b.png";